import { Component, Input } from '@angular/core';
import { ConfigurationService } from '../store/configuration.service';
import { LssConfigurationEntity } from '../store/configuration.datamodel';
import { DeploymentService } from '../../deployments/store/deployment.service';

@Component({
    selector: 'ama-ng-app-store-configuration-offices-list',
    templateUrl: './configuration-offices-list.component.html',
    styleUrls: ['./configuration-offices-list.component.scss'],
    standalone: false
})
export class ConfigurationOfficesListComponent {
  @Input() canCreateConfiguration = false;
  @Input() areConfigurationOverridesEnabled = false;

  constructor(protected configurationService: ConfigurationService,
              public readonly deploymentService: DeploymentService) {
  }

  onSelectOfficeDeploymentCheckboxChange(actor: LssConfigurationEntity) {
    if (actor.isSelected) {
      this.configurationService.onRemoveSelectedEntity([actor]);
    } else {
      this.configurationService.onAddSelectedEntity([actor]);
    }
  }

  toggleSelectAll(shouldSelect: boolean, offices: LssConfigurationEntity[]) {
    const enabledOffices = this.areConfigurationOverridesEnabled ? offices :
      offices.filter(office => !office.isParentDeployed);
    if (shouldSelect) {
      this.configurationService.onAddSelectedEntity(enabledOffices);
    } else {
      this.configurationService.onRemoveSelectedEntity(enabledOffices);
    }
  }
}
